import { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import Header from "../home/header";
import productData from "../store/product.json";
import nonGMO from '../../assets/home/non-gmo.png'
import glutenFree from '../../assets/home/glutenfree.png';
import Rostedinoliv from '../../assets/home/roasted-in-olive-oil.png'
import antiOxident from '../../assets/home/anti-Oxidant.png'
import noAddatives from '../../assets/home/no-added-preservatives.png'
import Footer from '../home/footer'
import { useCart } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";

const importAll = (r) => {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
};

// Import folders
const product1 = importAll(require.context("../../assets/product", false, /\.(png|jpg)$/));
const product2 = importAll(require.context("../../assets/product1", false, /\.(png|jpg)$/));
const product3 = importAll(require.context("../../assets/product2", false, /\.(png|jpg)$/));
const product4 = importAll(require.context("../../assets/product3", false, /\.(png|jpg)$/));
const product5 = importAll(require.context("../../assets/product4", false, /\.(png|jpg)$/));
const product6 = importAll(require.context("../../assets/product5", false, /\.(png|jpg)$/));
const product7 = importAll(require.context("../../assets/product6", false, /\.(png|jpg)$/));
const product8 = importAll(require.context("../../assets/product7", false, /\.(png|jpg)$/));
const product9 = importAll(require.context("../../assets/product8", false, /\.(png|jpg)$/));
const product10 = importAll(require.context("../../assets/product9", false, /\.(png|jpg)$/));
const product11 = importAll(require.context("../../assets/product10", false, /\.(png|jpg)$/));
const product12 = importAll(require.context("../../assets/product11", false, /\.(png|jpg)$/));
const product13 = importAll(require.context("../../assets/product12", false, /\.(png|jpg)$/));
const product14 = importAll(require.context("../../assets/product13", false, /\.(png|jpg)$/));
const product15 = importAll(require.context("../../assets/product14", false, /\.(png|jpg)$/));
const product16 = importAll(require.context("../../assets/product15", false, /\.(png|jpg)$/));
const product17 = importAll(require.context("../../assets/product16", false, /\.(png|jpg)$/));
const product18 = importAll(require.context("../../assets/product17", false, /\.(png|jpg)$/));
const product19 = importAll(require.context("../../assets/product18", false, /\.(png|jpg)$/));
const product20 = importAll(require.context("../../assets/product19", false, /\.(png|jpg)$/));
const product21 = importAll(require.context("../../assets/product20", false, /\.(png|jpg)$/));
const product22 = importAll(require.context("../../assets/product21", false, /\.(png|jpg)$/));


const ProductDescriptionPage = () => {
  const navigate=useNavigate();
  const { id } = useParams();
  const product = productData.find((item) => item.id === parseInt(id));

  const [qty, setQty] = useState(product ? Number(product.Quantity) : 1);
  const [mainImage, setMainImage] = useState("");

  const [selectedWeight, setSelectedWeight] = useState(product.Weight[0]);
  const [finalPrice, setFinalPrice] = useState(product.discounted);

  // Function to get image based on folder name
  const getImg = (folder, img) => {
    if (folder === "product") return product1[img];
    if (folder === "product1") return product2[img];
    if (folder === "product2") return product3[img];
    if (folder === "product3") return product4[img];
    if (folder === "product4") return product5[img];
    if (folder === "product5") return product6[img];
    if (folder === "product6") return product7[img];
    if (folder === "product7") return product8[img];
    if (folder === "product8") return product9[img];
    if (folder === "product9") return product10[img];
    if (folder === "product10") return product11[img];
    if (folder === "product11") return product12[img];
    if (folder === "product12") return product13[img];
    if (folder === "product13") return product14[img];
    if (folder === "product14") return product15[img];
    if (folder === "product15") return product16[img];
    if (folder === "product16") return product17[img];
    if (folder === "product17") return product18[img];
    if (folder === "product18") return product19[img];
    if (folder === "product19") return product20[img];
    if (folder === "product20") return product21[img];
    if (folder === "product21") return product22[img];

    return "";
  };

  useEffect(() => {
    if (product && product.image.length > 0) {
      setMainImage(getImg(product.folder, product.image[0]));
    }

    let price = product.discounted;

    if (selectedWeight === "20GM") price = product.discounted;
    if (selectedWeight === "50GM") price = product.discounted * 2;

    setFinalPrice(price * qty);
  }, [qty, selectedWeight, product]);

  if (!product) {
    return <h2 className="text-center mt-5">Product not found</h2>;
  }

  const increaseQty = () => {
    setQty(qty + 1);
  };

  const decreaseQty = () => {
    if (qty > 1) {
      setQty(qty - 1);
    }
  };

  // -------------------------------
  // ⭐ CORRECTED ADD TO CART
  // -------------------------------
const addToCart = async () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user || !user.email) {
    alert("Please login to add items to cart");
    navigate('/login')
    return;
  }

  let payload = {
    email: user.email,
    id: product.id,
    name: product.name,
    folder: product.folder,
    image: product.image,
    weight: selectedWeight,
    quantity: qty,
    price: product.discounted,
    totalPrice: finalPrice
  };

  await fetch("https://ankit1.jaskart.com/cart/add", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  alert("Product added to cart!");
  

};

const handleBuyNow = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user || !user.email) {
    alert("Please login to continue");
    navigate("/login");
    return;
  }

  navigate("/buynowcheckout", {
    state: {
      product: {
        id: product.id,
        name: product.name,
        folder: product.folder,
        image: product.image[0],
        weight: selectedWeight,
        quantity: qty,
        price: product.discounted,
        totalPrice: finalPrice
      }
    }
  });
};


  return (
    <>
      <Header />

      <div className="container-fluid" style={{ background: "linear-gradient(to right, #FFDA01, #f0a869ff)" }}>
        <div className="container py-5">

          <div className="row">
            {/* LEFT SIDE - IMAGE SLIDER */}
            <div className="col-md-7 text-center">

              <div
                style={{
                  padding: "10px",
                  background: "white",
                  borderRadius: "10px",
                  boxShadow: "6px 6px gray",
                }}
              >
                <img
                  src={mainImage}
                  alt={product.name}
                  style={{
                    maxHeight: "450px",
                    objectFit: "contain",
                  }}
                  className="img-fluid"
                />
              </div>

              {/* Thumbnails */}
              <div
                className="d-flex justify-content-center flex-wrap mt-4"
                style={{ gap: "15px" }}
              >
                {product.image.map((img, index) => (
                  <img
                    key={index}
                    src={getImg(product.folder, img)}
                    alt="thumbnail"
                    onClick={() => setMainImage(getImg(product.folder, img))}
                    style={{
                      width: "120px",
                      height: "120px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "3px solid yellow",
                      cursor: "pointer",
                      transition: "0.3s",
                    }}
                  />
                ))}
              </div>

            </div>

            {/* RIGHT SIDE */}
            <div className="col-md-5 text-dark">
              <h2 style={{ fontWeight: "700" }}>{product.name}</h2>

              <div className="mt-4 d-flex" style={{ gap: "10px" }}>
                <h4>₹{finalPrice}</h4>
                <h4 style={{ textDecoration: "line-through" }}>₹{product.price}</h4>
              </div>

              {/* <div className="d-flex align-items-center mt-4" style={{ gap: "10px" }}>
                <h6>Select Weight</h6>
                <select
                  className="form-select"
                  style={{
                    width: "200px",
                    borderRadius: "20px",
                    border: "1px solid black",
                    background: "none",
                    boxShadow: "6px 6px black",
                  }}
                  value={selectedWeight}
                  onChange={(e) => setSelectedWeight(e.target.value)}
                >
                  {product.Weight.map((w, index) => (
                    <option key={index} value={w}>
                      {w}
                    </option>
                  ))}
                </select>
              </div> */}

              {/* Quantity Section */}
              <div className="d-flex w-100 align-items-center mt-4" style={{ gap: "10px" }}>
                <h6>Quantity</h6>

                <button
                  onClick={decreaseQty}
                  style={{
                    background: "none",
                    borderRadius: "100%",
                    border: "1px solid black",
                    boxShadow: "-5px 4px black",
                  }}
                >
                  -
                </button>

                <p>{qty}</p>

                <button
                  onClick={increaseQty}
                  style={{
                    background: "none",
                    borderRadius: "100%",
                    border: "1px solid black",
                    boxShadow: "-5px 4px black",
                  }}
                >
                  +
                </button>
              </div>
              <button
                className="btn mt-3 px-4 py-2 w-100"
                style={{
                  background: "none",
                  borderRadius: "50px",
                  border: "1px solid black",
                  boxShadow: "5px 4px black",
                  fontWeight: "700",
                }}
                onClick={addToCart}
              >
                Add to Cart
              </button>


              <button
                className="btn mt-3 px-4 py-2 w-100"
                style={{
                  background: "none",
                  borderRadius: "50px",
                  border: "1px solid black",
                  boxShadow: "5px 4px black",
                  fontWeight: "700",
                }}
                onClick={handleBuyNow}
              >
                Buy Now
              </button>


              <p className="mt-4" style={{
                fontWeight:'600'
              }}>{product.description}</p>

              <div className="d-flex justify-content-between align-items-center w-100 mt-4" style={{
                fontWeight:'700',
                fontSize:'15px',
                textAlign:'center'
              }}>
                <div>
                {/* <img src={nonGMO} alt="Non GMO"/>  */}
                <p>Non-GMO</p>
                </div>
                <div className="">               
                {/* <img src={glutenFree} alt="Non GMO"/>                 */}
                <p>Gluten Free</p>
                </div>
                <div>
                {/* <img src={Rostedinoliv} alt="Non GMO"/> */}
                <p>Roasted in olive</p>
                </div>
                <div>               
                {/* <img src={antiOxident} alt="Non GMO"/>                 */}
                <p>Anti Oxidants</p>
                </div> 
                <div>
                {/* <img src={noAddatives} alt="Non GMO"/>                 */}
                <p>No Additives</p>
                </div>
              </div>

              <div className="mt-4">
                <div
                  className="d-flex justify-content-between"
                  style={{ fontWeight: "700", fontSize: "20px", marginBottom: "10px" }}
                >
                  <span>NUTRITIONAL INFORMATION</span>
                  <span>PER 100G</span>
                </div>

                <div style={{ borderTop: "2px solid black", marginBottom: "15px" }}></div>

                  {[
                    "Energy - 538.72 Kcal",
                    "Protein - 7.95 g",
                    "Carbohydrate - 61.12 g",
                    "Total Sugar - 0.50 g",
                    "Added Sugar - 0.00 g",
                    "Dietary Fiber - 3.45 g",
                    "Total Fat - 29.16 g",
                    "Saturated Fat - 13.65 g",
                    "Polyunsaturated Fat - 4.10 g",
                    "Monounsaturated Fat - 11.85 g",
                    "Trans Fat - 0.00 g",
                    "Cholesterol - 0.00 g",
                    "Sodium - 772.00 mg",
                    "Iron - 16.0 mg",
                    "Calcium - 56.0 mg",
                    "Vitamin D as D3 - 49.0 IU",
                    "Potassium - 86.0 mg",
                  ].map((item, index) => (
                    <div key={index} style={{ marginBottom: "18px" }}>
                      <p style={{ marginBottom: "5px", fontWeight: "600" }}>{item}</p>
                      <div style={{ borderBottom: "1px solid black" }}></div>
                    </div>
                  ))}
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid p-0" style={{background:'white'}}>
          <div className="container">
            
          </div>          
        </div>

      <Footer/>  
    </>
  );
};

export default ProductDescriptionPage;
